import { FEATURE_KEYS, FeatureFlagEnvironment } from './FeatureFlags';

export const RELEASE_HIGHLIGHTS_FEATURE_KEY = FEATURE_KEYS.releaseHighlights;
export const RELEASE_HIGHLIGHTS_BASELINE_VERSION = '2026.2.0';
export const RELEASE_HIGHLIGHTS_ACKNOWLEDGEMENT_KEY = 'ezrunpbra:releaseHighlightsAcknowledgement';
export const RELEASE_HIGHLIGHTS_WINDOW_DAYS = 30;
export const RELEASE_HIGHLIGHTS_ACKNOWLEDGEMENT_SCHEMA_VERSION = 1;
export const RELEASE_NOTES_WORKSHEET = 'Release Notes';
export const RELEASE_NOTES_RANGE = 'A2:D';

export interface Release {
  version: string;
  releasedAt: string;
  title: string;
  summary: string;
}

export interface ReleaseNoteRow {
  version: string;
  releasedAt: string;
  title: string;
  summary: string;
}

export interface FeatureFlagEnvironmentRule {
  featureKey: string;
  environment?: FeatureFlagEnvironment;
  description?: string;
  notes?: string;
}

export interface DeviceAcknowledgement {
  lastSeenVersion: string;
  seenAt: string;
  schemaVersion: number;
}

export interface ReleaseHighlightResult {
  release: Release | null;
  releases: Release[];
}
